module.exports = __webpack_public_path__ + "static/media/arara-azul.908b1bb9.mp3";